import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BookingCalendar.css';
import { Calendar } from '../../../packages/Calendar';
import { ICalendarContainerProps } from '../../../packages/Calendar/shared/containers/CalendarContainer/types';

interface IBookingCalendarWrapperProps {
  calendarOpen: boolean;
  preparedData: ICalendarContainerProps;
}

export const BookingCalendar = ({ preparedData, calendarOpen }: IBookingCalendarWrapperProps) => {
  if (!calendarOpen) {
    return null;
  }

  return (
    <div className={styles['calendar-wrapper']}>
      <Calendar {...preparedData} />
      {preparedData.loading && (
        <div className={styles['spinner-container']}>
          <Spinner />
        </div>
      )}
    </div>
  );
};
